import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { AuthStateService } from '../services/auth-state.service';

@Directive({
  selector: '[withFeature]'
})
export class WithFeatureDirective implements OnInit {

  @Input() withFeature: string = null;

  constructor(
    private auth: AuthStateService,
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) { }

  ngOnInit() {
    if (!this.auth.hasFeature(this.withFeature)) {
      this.renderer.removeChild(this.elementRef.nativeElement.parentNode, this.elementRef.nativeElement);
    }
  }

}
